import React from "react";
import { NavLink } from "react-router-dom";
import { MdEdit } from "react-icons/md";
import axios from "axios";
import { API_URL1 } from "../services/url";
import TablePagination from "@material-ui/core/TablePagination";
import { TableCell, TableRow } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import Paper from "@material-ui/core/Paper";
import TableBody from "@material-ui/core/TableBody";
import { Box } from "@mui/material/";
import { Grid } from "@mui/material";
import TruckDetail from "./TruckInfo";
import { LinearProgress } from "@material-ui/core";
import { withAlert } from "react-alert";
import moment from "moment-timezone";
import DispatchButtons from "./DispatchButtons";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AddLocationAltSharpIcon from "@mui/icons-material/AddLocationAltSharp";

const getDispatchDateValue = (item) =>
  item?.departed_quarry ||
  item?.loaded ||
  item?.dispatch_date ||
  item?.to_date ||
  item?.dsr_dt ||
  item?.created_at ||
  item?.updated_at ||
  item?.job_created_at ||
  item?.date ||
  item?.order_date ||
  null;

// Format the "Date Dispatched" cell correctly:
// - A REAL event timestamp (truck left quarry / loaded / completed / delivery_time)
//   is a true UTC instant → show it in Arizona time (America/Phoenix).
// - A SCHEDULE DATE (dsr_dt / to_date / ...) is a date-only value stored at
//   midnight UTC. It has NO clock time. Render the calendar day in UTC so it is
//   never shifted back to the previous evening (the "Jun 21, 5:00 PM" bug).
const getDispatchDateLabel = (item) => {
  const instant = item?.departed_quarry || item?.loaded || item?.completed || item?.delivery_time;
  if (instant) return moment.tz(instant, "America/Phoenix").format("lll");
  const dateOnly =
    item?.dispatch_date || item?.to_date || item?.dsr_dt || item?.date || item?.order_date ||
    item?.created_at || item?.updated_at || item?.job_created_at;
  if (dateOnly) return moment.utc(dateOnly).format("ll");
  return "N/A";
};


class Dispatcher extends React.Component {
  constructor() {
    super();
    this.state = {
      page: 0,
      rowsPerPage: 100,
      recentOrder: [],
      record: false,
      hideMAP: false,
      pagination: null,
      sortedByDeparted: false,
      sordedByPU: false,
      sortedByCrossStreet: false,
      sortedByDelivered: false,
      sortedByJobName: false,
      sortedByPickup: false,
      sortedByQty: false,
      sortedById: false,
      sortedByLot: false,
      sortedByLotAddress: false,
      sortedByName: false,
      sortedByContract: false,
      sortedByStatus:false,

      nonFilteredData: [],
      btn_status: "unclicked",
      showChangeModal: false,
      modalItem: null,
      dataPU: null,
      availTrucks: [],
      Udata: [],
      select_truck_type: "",
      truck_capacity: "",
      truck_id: "",
      driver_id: "",
      driver_name: "",
      truck_quantity: 0,
      no_of_trips: "",
      capacity_error: "no",
      sub_job_truck_id: null,
      btn_clicked: null,
    };
  }

  componentDidMount = async () => {
    try {
      const { page, rowsPerPage } = this.state;
      const response = await axios.get(
        `${API_URL1}trucker/dispatch/dispatched?page=${page + 1}&limit=${rowsPerPage}`,
        {
          headers: {
            "x-access-token": localStorage.getItem("TruckertokenKey"),
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
      );

      if (response.data.data) {
        this.setState({
          recentOrder: response.data.data,
          nonFilteredData: response.data.data,
          pagination: response.data.pagination,
          record: true,
        });
      } else {
        this.setState({ 
          recentOrder: [], 
          pagination: null,
          record: true 
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  openChangeTruckerModal = async (item) => {
    try {
      const truckQty = item.processing_quantity || item.true_quantity || 0;
      this.setState({
        showChangeModal: true,
        modalItem: item,
        sub_job_truck_id: item.sub_job_truck_id,
        truck_quantity: Number(truckQty) || 0,
        dataPU: null,
        availTrucks: [],
        Udata: [],
        select_truck_type: "",
        truck_capacity: "",
        truck_id: "",
        driver_id: item.driver_id || "",
        driver_name: item.driver_name || "",
        no_of_trips: "",
        capacity_error: "no",
        btn_clicked: null,
      });

      const response = await axios.get(
        `${API_URL1}trucker/driver/getDrivers?truck_company_id=${Number(
          localStorage.getItem("adminid")
        )}`,
        {
          headers: {
            "x-access-token": localStorage.getItem("TruckertokenKey"),
            "content-type": "application/json",
          },
        }
      );
      this.setState({ Udata: response.data.trucks || [] });
    } catch (error) {
      console.log(error);
    }
  };

  closeChangeTruckerModal = () => {
    this.setState({ showChangeModal: false });
  };

  handleModalDateChange = async (newDate) => {
    this.setState({ dataPU: newDate });
    const formdata1 = {
      truck_company_id: localStorage.getItem("adminid"),
      dates: moment(newDate).format("yyyy-MM-DD"),
    };
    try {
      const response2 = await axios.post(
        `${API_URL1}trucker/dispatch/availTruck1`,
        formdata1
      );
      this.setState({ availTrucks: response2.data.Trucks || [] });
    } catch (error) {
      console.log(error);
    }
  };

  handleModalTruckSelect = async (evt) => {
    evt.preventDefault();
    if (evt.target.value) {
      const values = evt.target.value.split(",");
      const selectedTruckId = values[0];
      const capacity = Number(values[1]);
      const type = values[2];
      const truckQuantity = Number(this.state.truck_quantity) || 0;

      let trips = 1;
      if (capacity && truckQuantity) {
        trips = truckQuantity % capacity !== 0 ? parseInt(truckQuantity / capacity) + 1 : truckQuantity / capacity;
      }

      this.setState({
        truck_id: selectedTruckId,
        truck_capacity: capacity,
        select_truck_type: type,
        no_of_trips: trips,
        capacity_error: capacity < truckQuantity ? "yes" : "no",
      });

      if (selectedTruckId) {
        try {
          const response = await axios.get(
            `${API_URL1}dispatcher/driverName?truck_id=${selectedTruckId}`
          );
          if (response.data.Name && response.data.Name[0] && response.data.Name[0].name) {
            this.setState({
              driver_name: response.data.Name[0].name,
              driver_id: response.data.Name[0].truck_company_user_id,
            });
          }
        } catch (error) {
          this.setState({ driver_name: "", driver_id: "" });
        }
      }
    }
  };

  handleModalDriverSelect = (evt) => {
    const parts = evt.target.value.split(",");
    this.setState({ driver_name: parts[0], driver_id: parts[3] });
  };

  submitChangeTrucker = async (evt) => {
    evt.preventDefault();
    const alert = this.props.alert;
    try {
      if (!this.state.driver_id) {
        alert.error("Please select driver");
        return;
      }

      this.setState({ btn_clicked: "clicked" });
      const formdata = {
        sub_job_truck_id: this.state.sub_job_truck_id,
        driver_id: Number(this.state.driver_id),
      };
      const response = await axios.post(
        `${API_URL1}trucker/dispatch/updateDriver`,
        formdata,
        {
          headers: {
            "x-access-token": localStorage.getItem("TruckertokenKey"),
            "Access-Control-Allow-Origin": "*",
          },
        }
      );

      if (response.data.success) {
        alert.success(response.data.message || "Driver updated", {
          onClose: () => {
            window.location.reload();
          },
        });
      } else {
        alert.error("Unable to update driver", {
          onClose: () => {
            this.closeChangeTruckerModal();
          },
        });
      }
    } catch (error) {
      console.log(error);
      this.props.alert.error("Something went wrong");
    }
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, async () => {
      try {
        const response = await axios.get(
          `${API_URL1}trucker/dispatch/dispatched?page=${newPage + 1}&limit=${this.state.rowsPerPage}`,
          {
            headers: {
              "x-access-token": localStorage.getItem("TruckertokenKey"),
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        );

        if (response.data.data) {
          this.setState({
            recentOrder: response.data.data,
            nonFilteredData: response.data.data,
            pagination: response.data.pagination,
            record: true,
          });
        }
      } catch (error) {
        console.log(error);
      }
    });
  };

  handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value);
    this.setState({ 
      rowsPerPage: newLimit,
      page: 0 
    }, async () => {
      try {
        const response = await axios.get(
          `${API_URL1}trucker/dispatch/dispatched?page=1&limit=${newLimit}`,
          {
            headers: {
              "x-access-token": localStorage.getItem("TruckertokenKey"),
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        );

        if (response.data.data) {
          this.setState({
            recentOrder: response.data.data,
            nonFilteredData: response.data.data,
            pagination: response.data.pagination,
            record: true,
          });
        }
      } catch (error) {
        console.log(error);
      }
    });
  };

  sortQty = () => {
    const { recentOrder } = this.state;
    if (this.state.sortedByQty) {
      this.setState({ recentOrder: recentOrder.reverse() });
    } else {
      var data = recentOrder;
      data.sort((a, b) => {
        if (a.processing_quantity < b.processing_quantity) {
          return -1;
        }
        if (a.processing_quantity > b.processing_quantity) {
          return 1;
        }
        return 0;
      });

      this.setState({ recentOrder: data, sortedByQty: true });
    }
  };
  sortJobName = () => {
    const { recentOrder } = this.state;
    if (this.state.sortedByJobName) {
      this.setState({ recentOrder: recentOrder.reverse() });
    } else {
      var data = recentOrder;
      data.sort((a, b) => {
        if (a.customer_site_name < b.customer_site_name) {
          return -1;
        }
        if (a.customer_site_name > b.customer_site_name) {
          return 1;
        }
        return 0;
      });

      this.setState({ recentOrder: data, sortedByJobName: true });
    }
  };

  sortStatus = () => {
    const { recentOrder } = this.state;
    if (this.state.sortedByStatus) {
      this.setState({ recentOrder: recentOrder.reverse() });
    } else {
      var data = recentOrder;
      data.sort((a, b) => {
        if (a.status < b.status) {
          return -1;
        }
        if (a.status > b.status) {
          return 1;
        }
        return 0;
      });

      this.setState({ recentOrder: data, sortedByStatus: true });
    }
  };
  sortPickup = () => {
    const { recentOrder } = this.state;
    if (this.state.sortedByPickup) {
      this.setState({ recentOrder: recentOrder.reverse() });
    } else {
      var data = recentOrder;
      data.sort((a, b) => {
        if (a.sub_job_truck_id < b.sub_job_truck_id) {
          return -1;
        }
        if (a.sub_job_truck_id > b.sub_job_truck_id) {
          return 1;
        }
        return 0;
      });

      this.setState({ recentOrder: data, sortedByPickup: true });
    }
  };
  sortCrossStreet = () => {
    const { recentOrder } = this.state;
    if (this.state.sortedByCrossStreet) {
      this.setState({ recentOrder: recentOrder.reverse() });
    } else {
      var data = recentOrder;
      data.sort((a, b) => {
        if (a.cross_streets < b.cross_streets) {
          return -1;
        }
        if (a.cross_streets > b.cross_streets) {
          return 1;
        }
        return 0;
      });
      this.setState({ recentOrder: data, sortedByCrossStreet: true });
    }
  };
  sortPU = () => {
    const { recentOrder } = this.state;
    if (this.state.sortedByPU) {
      this.setState({ recentOrder: recentOrder.reverse() });
    } else {
      var data = recentOrder;
      data.sort((a, b) => {
        if (a.quarry_site_name < b.quarry_site_name) {
          return -1;
        }
        if (a.quarry_site_name > b.quarry_site_name) {
          return 1;
        }
        return 0;
      });
      this.setState({ recentOrder: data, sortedByPU: true });
    }
  };
  sortdelvered = () => {
    const { recentOrder } = this.state;
    if (this.state.sortedByDelivered) {
      this.setState({ recentOrder: recentOrder.reverse() });
    } else {
      var data = recentOrder;
      data.sort((a, b) => {
        if (a.Delivered_on < b.Delivered_on) {
          return -1;
        }
        if (a.Delivered_on > b.Delivered_on) {
          return 1;
        }
        return 0;
      });

      this.setState({ recentOrder: data, sortedByDelivered: true });
    }
  };
  sortDeparted = () => {
    const { recentOrder } = this.state;
    if (this.state.sortedByDeparted) {
      this.setState({ recentOrder: recentOrder.reverse() });
    } else {
      var data = recentOrder;
      data.sort((a, b) => {
        const aDate = getDispatchDateValue(a);
        const bDate = getDispatchDateValue(b);

        if (!aDate && !bDate) return 0;
        if (!aDate) return 1;
        if (!bDate) return -1;

        return new Date(aDate) - new Date(bDate);
      });

      this.setState({ recentOrder: data, sortedByDeparted: true });
    }
  };
  sortID = () => {
    const { recentOrder } = this.state;
    if (this.state.sortedById) {
      this.setState({ recentOrder: recentOrder.reverse() });
    } else {
      var data = recentOrder;
      data.sort((a, b) => {
        if (a.pk < b.pk) {
          return -1;
        }
        if (a.pk > b.pk) {
          return 1;
        }
        return 0;
      });

      this.setState({ recentOrder: data, sortedById: true });
    }
  };
  sortLOT = () => {
    const { recentOrder } = this.state;
    if (this.state.sortedByLot) {
      this.setState({ recentOrder: recentOrder.reverse() });
    } else {
      var data = recentOrder;
      data.sort((a, b) => {
        if (a.lot < b.lot) {
          return -1;
        }
        if (a.lot > b.lot) {
          return 1;
        }
        return 0;
      });

      this.setState({ recentOrder: data, sortedByLot: true });
    }
  };
  sortLOTAdress = () => {
    const { recentOrder } = this.state;
    if (this.state.sortedByLotAddress) {
      this.setState({ recentOrder: recentOrder.reverse() });
    } else {
      var data = recentOrder;
      data.sort((a, b) => {
        if (a.lot_address < b.lot_address) {
          return -1;
        }
        if (a.lot_address > b.lot_address) {
          return 1;
        }
        return 0;
      });

      this.setState({ recentOrder: data, sortedByLotAddress: true });
    }
  };
  sortCName = () => {
    const { recentOrder } = this.state;
    if (this.state.sortedByContract) {
      this.setState({ recentOrder: recentOrder.reverse() });
    } else {
      var data = recentOrder;
      data.sort((a, b) => {
        if (a.site_person_contact < b.site_person_contact) {
          return -1;
        }
        if (a.site_person_contact > b.site_person_contact) {
          return 1;
        }
        return 0;
      });

      this.setState({ recentOrder: data, sortedByContract: true });
    }
  };
  sortPName = () => {
    const { recentOrder } = this.state;
    if (this.state.sortedByName) {
      this.setState({ recentOrder: recentOrder.reverse() });
    } else {
      var data = recentOrder;
      data.sort((a, b) => {
        if (a.site_person_name < b.site_person_name) {
          return -1;
        }
        if (a.site_person_name > b.site_person_name) {
          return 1;
        }
        return 0;
      });

      this.setState({ recentOrder: data, sortedByName: true });
    }
  };
  completeOrder = async (
    sub_job_id,
    truck_id,
    sub_job_truck_id,
    job_detail_id
  ) => {
    this.setState({ btn_status: "clicked" });

    const alert = this.props.alert;
    const id = {
      sub_job_id: sub_job_id,
      truck_id: truck_id,
      sub_job_truck_id: sub_job_truck_id,
      job_detail_id: job_detail_id,
    };
    try {
      const response = await axios.post(`${API_URL1}driver/submitJob`, id, {
        headers: {
          "x-access-token": `${localStorage.getItem("TruckertokenKey")}`,
          "content-type": "application/json",
        },
      });

      if (response.data.success) {
        alert.success(response.data.message, {
          onClose: () => {
            window.location.reload()
            // window.location = "/dispatched_order";
          },
        });
      }
    } catch (error) {
      alert.error("something went wrong");
    }
  };
  handleSearchChange = (e) => {
    var { nonFilteredData } = this.state;
    let searchQuery = e.target.value;

    if (searchQuery !== "") {
      const Sdata = nonFilteredData;
      var data = Sdata.filter((data) => {
        return (
          (data.mssql_order_id &&
            String(data.mssql_order_id).toLowerCase().includes(searchQuery)) ||
          (data.order_id &&
            String(data.order_id).toLowerCase().includes(searchQuery)) ||
          (data.po_number &&
            String(data.po_number).toLowerCase().includes(searchQuery)) ||
          (data.pk && String(data.pk).toLowerCase().includes(searchQuery)) ||
          (data.lot && data.lot.toLowerCase().includes(searchQuery)) ||
          (data.lot_address &&
            data.lot_address.toLowerCase().includes(searchQuery)) ||
          (data.quantity &&
            String(data.quantity).toLowerCase().includes(searchQuery)) ||
          (data.color && data.color.toLowerCase().includes(searchQuery)) ||
          (data.customer_site_name &&
            data.customer_site_name.toLowerCase().includes(searchQuery)) ||
          (data.quarry_site_name &&
            data.quarry_site_name.toLowerCase().includes(searchQuery)) ||
          (data.sub_job_truck_id &&
            String(data.sub_job_truck_id)
              .toLowerCase()
              .includes(searchQuery)) ||
          (data.cross_streets &&
            data.cross_streets.toLowerCase().includes(searchQuery))
        );
      });
      this.setState({ recentOrder: data });
    } else {
      this.setState({ recentOrder: nonFilteredData });
    }
  };
  render() {
    const { page, rowsPerPage, recentOrder } = this.state;
    console.log("items", recentOrder);
    return (
      <Grid container spacing={2} style={{ padding: '0 20px' }}>
        {!this.state.record ? <LinearProgress /> : ""}
      <Grid xs={12} sm={12} mb={2}>
          <DispatchButtons />
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '16px 20px', marginTop: '8px' }}>
            <div style={{ width: 40, height: 40, borderRadius: 8, background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ffffff', boxShadow: '0 8px 16px rgba(99,102,241,0.25)' }}>
              <LocalShippingIcon fontSize="small" />
            </div>
            <h1 style={{ margin: 0, fontWeight: 800, fontSize: 24, color: '#0f172a' }}>Dispatched Loads</h1>
          </div>
        </Grid>
        <Grid xs={12} sm={12} mt={1} mr={5}>
          {!this.state.record && recentOrder.length === 0 ? (
            <div style={{ width: "90%", marginLeft: "3%" }}>
              Loading.........
            </div>
          ) : recentOrder.length === 0 && this.state.record ? (
            <div style={{ width: "90%", marginLeft: "3%" }}>
              No Record Available
            </div>
          ) : (
            <Paper style={{ width: "96%", margin: "16px auto", border: '1px solid #e5e7eb', borderRadius: 12, boxShadow: '0 8px 16px rgba(2,6,23,0.06)' }}>
              <TableContainer style={{ maxHeight: "65vh", overflow: "auto" }}>
                <Table
                  stickyHeader
                  aria-label="simple table"
                  style={{ color: "#0f172a" }}
                >
                  <TableHead style={{ backgroundColor: "#f1f5f9" }}>
                    <TableRow>
                    <TableCell
                        style={{ backgroundColor: "#f1f5f9", color: "#0f172a", minWidth: 150, paddingLeft: "45px", fontWeight: 800 }}
                      >
                        Action
                      </TableCell>
                      {/* <TableCell
                        style={{
                          backgroundColor: "#000000",
                          color: "white",
                          minWidth: 100,
                        }}
                      >
                        Order
                      </TableCell> */}
                      <TableCell style={{ backgroundColor: "#f1f5f9", color: "#0f172a", minWidth: 100, fontWeight: 800 }}
                      >
                        <i
                          style={{ cursor: "pointer", marginRight: "2px" }}
                          className="fa fa-sort"
                          aria-hidden="true"
                          onClick={this.sortID}
                        />
                        P/U #:
                      </TableCell>
                      <TableCell style={{ backgroundColor: "#f1f5f9", color: "#0f172a", minWidth: 150, fontWeight: 800 }}
                      >
                        <i
                          style={{ cursor: "pointer", marginRight: "2px" }}
                          className="fa fa-sort"
                          aria-hidden="true"
                          onClick={this.sortDeparted}
                        />
                        Date Dispatched
                      </TableCell>
                      <TableCell style={{ backgroundColor: "#f1f5f9", color: "#0f172a", minWidth: 100, fontWeight: 800 }}
                      >
                        <i
                          style={{ cursor: "pointer", marginRight: "2px" }}
                          className="fa fa-sort"
                          aria-hidden="true"
                          onClick={this.sortID}
                        />
                        Customer Name
                      </TableCell>
                      {/* <TableCell
                        style={{
                          backgroundColor: "#000000",
                          color: "white",
                          minWidth: 150,
                        }}
                      >
                        <i
                          style={{ cursor: "pointer", marginRight: "2px" }}
                          className="fa fa-sort"
                          aria-hidden="true"
                          onClick={this.sortQty}
                        />
                        Qty
                      </TableCell> */}
                      <TableCell style={{ backgroundColor: "#f1f5f9", color: "#0f172a", minWidth: 150, fontWeight: 800 }}
                      >
                        Job
                      </TableCell>
                      <TableCell style={{ backgroundColor: "#f1f5f9", color: "#0f172a", minWidth: 150, fontWeight: 800 }}
                      >
                        <i
                          style={{ cursor: "pointer", marginRight: "2px" }}
                          className="fa fa-sort"
                          aria-hidden="true"
                          onClick={this.sortJobName}
                        />
                        Load Qty
                      </TableCell>
                      <TableCell
                        style={{ backgroundColor: "#f1f5f9", color: "#0f172a", minWidth: 150, fontWeight: 800 }}
                      >
                        Truck
                      </TableCell>
                      <TableCell style={{ backgroundColor: "#f1f5f9", color: "#0f172a", minWidth: 150, fontWeight: 800 }}
                      >
                        <i
                          style={{ cursor: "pointer", marginRight: "2px" }}
                          className="fa fa-sort"
                          aria-hidden="true"
                          onClick={this.sortPU}
                        />
                        P/U Quarry
                      </TableCell>

                    </TableRow>
                  </TableHead>
                  <TableBody style={{ backgroundColor: "#ffffff" }}>
                    {recentOrder &&
                      recentOrder.map((item, key) => {
                          return (
                            <TableRow
                              key={item.name}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                               <TableCell style={{ width: 160 }}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: 1,
                                  }}
                                >
                                  
                                  <NavLink
                                    to={`/dispatched_map/${item.sub_job_truck_id}`}
                                  >
                                    <AddLocationAltSharpIcon
                                      style={{ marginRight: "3px" }}
                                    />
                                  </NavLink>
                                  {/* <DownloadQuote
                                    sub_job_truck_id={item.sub_job_truck_id}
                                  />
                                  <DownloadPdf pdf={item.upload_map_file} /> */}
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => this.openChangeTruckerModal(item)}
                                  >
                                    <MdEdit
                                      style={{
                                        color: "#0075ff",
                                        fontSize: "17px",
                                        marginLeft: "12px",
                                      }}
                                      title="Change Trucker"
                                    />
                                  </span>
                                </Box>
                              </TableCell>
                              {/* <TableCell>
                                <OrderDetail
                                  pickup_Date={item.to_date}
                                  color_name={item.color_name}
                                  size={item.size}
                                  qty={item.processing_quantity}
                                  job_name={item.customer_site_name}
                                  PO_No={item.PO_No}
                                  cross_streets={item.cross_streets}
                                />
                              </TableCell> */}
                              <TableCell style={{ minWidth: 150 }}>
                                {item.mssql_order_id}
                              </TableCell>
                              <TableCell>
                                {getDispatchDateLabel(item)}
                              </TableCell>
                              <TableCell style={{ minWidth: 150 }}>
                              {item.customer_name
                                ? item.customer_name
                                : "N/A"}
                            </TableCell>
                            <TableCell style={{ minWidth: 150 }}>
                              {item.job_name}
                            </TableCell>
                              {/* <TableCell>
                                {item.quantity
                                  ? parseFloat(
                                      item.quantity
                                    ).toFixed(2)
                                  : "N/A"}
                              </TableCell> */}
                              <TableCell>
                                {item?.true_quantity
                                  ? parseFloat(
                                      item?.true_quantity
                                    ).toFixed(2)
                                  : "N/A"}
                              </TableCell>
                              <TableCell>
                                <TruckDetail
                                  truck={item.registration_number}
                                  driver_name={item.driver_name}
                                  // sub_job_truck_id={item.sub_job_id}
                                  phone_no={item.phone_no}
                                />
                              </TableCell>
                              <TableCell>{item.quarry_site_name}</TableCell>

                            </TableRow>
                          );
                        })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={this.state.pagination ? this.state.pagination.totalItems : 0}
                page={page}
                onPageChange={this.handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 20, 50, 100]}
                style={{ fontSize: 16 }}
              />
            </Paper>
          )}
        </Grid>
        <div hidden>
          {/* <CurrentLocation /> */}
        </div>
        {this.state.showChangeModal ? (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2000,
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: "8px",
                padding: "20px",
                width: "700px",
                maxWidth: "90%",
              }}
            >
              <h4 style={{ marginBottom: "15px" }}>Change Trucker</h4>
              <form onSubmit={this.submitChangeTrucker}>
                <div className="row form-group" style={{ marginBottom: "10px" }}>
                  <label className="col-lg-4 pt-2">Driver</label>
                  <div className="col-lg-8">
                    <select className="form-control" onChange={this.handleModalDriverSelect} required>
                      <option value="">Select</option>
                      {this.state.Udata &&
                        this.state.Udata.map((item, key) => (
                          <option
                            key={key}
                            value={[item.name, item.truck_id, item.phone_no, item.truck_company_user_id, item.type]}
                          >
                            {item.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                  <button type="button" className="btn btn-secondary" onClick={this.closeChangeTruckerModal}>Cancel</button>
                  <button type="submit" className="btn btn-primary" disabled={this.state.btn_clicked === "clicked"}>Update</button>
                </div>
              </form>
            </div>
          </div>
        ) : null}
      </Grid>
    );
  }
}

export default withAlert()(Dispatcher);
